import React, { Component } from 'react';
import { connect } from 'react-redux';

import { submit, isSubmitting } from 'redux-form';

import EventTimeline from 'components/shared/EventTimeline';

import { CardText } from 'material-ui/Card';

import { AccentColor } from 'helpers/AccentColorHelper';
import { deepDiver } from 'helpers/utilities';

import FlatButton from 'material-ui/FlatButton';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import PauseIcon from '@material-ui/icons/Pause';
import DeferIcon from '@material-ui/icons/AccessTime';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeNext } from 'helpers/MUIFiles';

import { CSSTransitionGroup } from 'react-transition-group';

import FooterButtons from 'components/shared/FooterButtons';
import TicketStatusIcon from 'components/tenant_app/components/tenant_dashboard/TicketStatusIcon';
import TaskList from 'components/shared/TaskList';

import TicketInformationForm from './TicketInformation';
import RequestContractorForm from './RequestContractorForm';
import AssignTicketForm from './AssignTicketForm';
import FinishJobForm from './FinishPauseJobForm';

import * as TimerActions from 'actions/timerActions';
import {
  pauseMaintenanceJob,
  requireContractor,
  completeMaintenanceJob,
  createOrUpdateMaintenanceTask,
  claimTicket,
  getListOfMaintenanceStaff,
} from 'actions/maintenanceActions';
import { getMaintenanceWorkerTicket } from 'actions/maintenanceTicketActions';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';

const pageViewHeaders = {
  DETAILS: { name: 'details', formName: '' },
  SHOWCONTRACTOR: { name: 'showContractor', formName: '' },
  ASSIGNTICKET: { name: 'assignTicket', formName: '' },
  EVENTS: { name: 'events', formName: '' },
  SHOWENDJOB: { name: 'endJob', formName: '' },
  TASKS: { name: 'tasks', formName: '' },
};

let style = {
  transaction_card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
  },
  button: {
    marginLeft: '5px',
    color: '#3383ee',
    border: '2px solid #3383ee',
    '&:hover': {
      border: '2px solid #3383ee',
      backgroundColor: 'rgba(51, 131, 238, 0.1)',
    },
  },
};

export default withMobileDialog()(
  connect(
    store => ({
      userId: store.userTypes.userId,
      ticketDetails: store.maintenanceTicket.ticketDetails,
      claimTickets: store.userTypes.claimTickets,
      assignTickets: store.userTypes.assignTickets,
      time: store.timer.time,
      maintenanceStaff: store.maintenanceReducer.maintenance,
      submitting: isSubmitting('update_status_maintenance_form')(store),
    }),
    {
      ...TimerActions,
      pauseMaintenanceJob,
      requireContractor,
      completeMaintenanceJob,
      submit,
      createOrUpdateMaintenanceTask,
      claimTicket,
      getMaintenanceWorkerTicket,
      getListOfMaintenanceStaff,
    }
  )(
    class MaintenanceWorkerTicketsOverview extends Component {
      constructor(props) {
        super(props);
        this.state = {
          openView: pageViewHeaders.DETAILS.name,
          jobStarted: false,
          showContractorDialog: false,
          completeStepNumber: 1,
          enableSignButton: false,
          hideSubmitButton: false,
        };
      }

      componentDidMount = () => {
        this.props.getListOfMaintenanceStaff(this.props.ticketDetails.property_id);
      };

      pageView = pageToView => {
        this.setState({
          openView: pageToView.name,
          formName: pageToView.formName,
        });
      };

      startJob = () => {
        if (!this.state.jobStarted) {
          let clone = { ...this.props.ticketDetails };
          clone.status = 'Fixing';
          this.props.updateTicket(clone, this.props.ticketDetails.id);
        }

        this.setState({ jobStarted: !this.state.jobStarted });
      };

      toggleDrawer = () => {
        if (this.state.jobStarted) {
          this.pauseJob();
        }
        this.setState({ completeStepNumber: 1 });
        this.props.toggleDrawer();
      };

      deferJob = () => {
        let clone = { ...this.props.ticketDetails };
        clone.status = 'Deferred';
        this.props.updateTicket(clone, this.props.ticketDetails.id);

        this.setState({
          jobStarted: !this.state.jobStarted,
          openView: pageViewHeaders.DETAILS.name,
        });
      };

      pauseJob = () => {
        this.props.pauseMaintenanceJob(this.props.time, this.props.ticketDetails.id).then(() => {
          this.startJob();
          this.setState({ openView: pageViewHeaders.DETAILS.name });
        });
      };

      toggleContractorDialog = () => {
        if (this.state.openView === pageViewHeaders.SHOWCONTRACTOR.name) {
          this.setState({ openView: pageViewHeaders.DETAILS.name });
          return;
        }
        this.setState({ openView: pageViewHeaders.SHOWCONTRACTOR.name });
      };

      toggleAssignTicket = () => {
        if (this.state.openView === pageViewHeaders.ASSIGNTICKET.name) {
          this.setState({ openView: pageViewHeaders.DETAILS.name });
          return;
        }
        this.setState({ openView: pageViewHeaders.ASSIGNTICKET.name });
      };

      requireContractor = formData => {
        this.props
          .requireContractor(formData, this.props.time, this.props.ticketDetails.id)
          .then(() => {
            this.props.getAllTickets();
            this.toggleContractorDialog();
            this.startJob();
          });
      };

      toggleEndJobDialog = () => {
        if (this.state.openView === pageViewHeaders.SHOWENDJOB.name) {
          this.setState({ openView: pageViewHeaders.DETAILS.name });
          return;
        }
        this.setState({ openView: pageViewHeaders.SHOWENDJOB.name });
      };

      submitCompleteJob = formData => {
        if (this.state.completeStepNumber === 1) {
          this.setState({ completeStepNumber: 2 });
        } else {
          return this.props
            .completeMaintenanceJob(
              formData,
              this.props.time,
              this.props.signaturePNG,
              this.props.ticketDetails.id
            )
            .then(() => {
              this.props.getAllTickets();
              this.enableSignButton(false);
              this.toggleEndJobDialog();
              this.setState({ completeStepNumber: 1 });
              this.startJob();
            });
        }
      };

      enableSignButton = enableSignButton => {
        this.setState({ enableSignButton });
      };

      footerBackButtonVerbiage = () => {
        let verbiage = 'Close';
        if (
          this.state.openView !== pageViewHeaders.DETAILS.name &&
          this.state.openView !== pageViewHeaders.EVENTS.name
        ) {
          verbiage = 'Back';
        }
        return verbiage;
      };

      submitButtonVerbiage = () => {
        const { ticketDetails, userId } = this.props;
        let verbiage = 'Start Job';
        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 1
        ) {
          return 'Next';
        }

        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 2
        ) {
          return 'Complete';
        }

        if (
          (ticketDetails.assigned_to_id === userId && ticketDetails.status === 'Fixing') ||
          this.state.jobStarted
        ) {
          return 'End/Pause Job';
        }
        return verbiage;
      };

      submitButtonAction = () => {
        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 1
        ) {
          this.props.submit('update_status_maintenance_form');
          return;
        }

        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 2
        ) {
          this.props.submit('update_status_maintenance_form');
          return;
        }

        if (this.state.jobStarted) {
          this.toggleEndJobDialog();
          return;
        }

        this.startJob();

        return;
      };

      shouldDisableSubmitButton = () => {
        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 2
        ) {
          if (this.state.enableSignButton && this.props.submitting) {
            return false;
          }

          return this.state.enableSignButton;
        }

        return true;
      };

      hideSubmitButton = () => {
        let hideButton = false;
        if (this.state.openView === pageViewHeaders.SHOWCONTRACTOR.name) {
          hideButton = true;
        }
        return hideButton;
      };

      footerBackButtonAction = () => {
        if (this.state.openView === pageViewHeaders.SHOWCONTRACTOR.name) {
          this.toggleContractorDialog();
          return;
        }

        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 2
        ) {
          this.setState({ completeStepNumber: 1 });
          this.enableSignButton(false);
          return;
        }

        if (
          this.state.openView === pageViewHeaders.SHOWENDJOB.name &&
          this.state.completeStepNumber === 1
        ) {
          this.toggleEndJobDialog();
          return;
        }

        this.toggleDrawer();
        return;
      };

      createOrUpdateTask = (task, taskID) => {
        this.props.createOrUpdateMaintenanceTask(task, taskID, this.props.ticketDetails.id);
      };

      claimTicket = async () => {
        const maintenanceTicketID = this.props.ticketDetails.id;
        await this.props.claimTicket(maintenanceTicketID);
        this.props.getMaintenanceWorkerTicket(maintenanceTicketID);
      };

      assignTicket = async formData => {
        const maintenanceTicketID = this.props.ticketDetails.id;
        const maintenanceTicketDetails = { ...this.props.ticketDetails, assign: formData.assign };
        await this.props.updateTicket(maintenanceTicketDetails, maintenanceTicketID);
        this.props.getMaintenanceWorkerTicket(maintenanceTicketID);
        this.toggleAssignTicket();
      };

      acknowledgeTicket = async () => {
        const maintenanceTicketID = this.props.ticketDetails.id;
        let clone = { ...this.props.ticketDetails };
        clone.status = 'Acknowledged';
        await this.props.updateTicket(clone, maintenanceTicketID);
        this.props.getMaintenanceWorkerTicket(maintenanceTicketID);
      };

      render() {
        const { handleSubmit } = this.props;

        const headerColumns = this.props.ticketDetails.tasks.length > 0 ? 'col-xs-4' : 'col-xs-6';
        return (
          <MuiThemeProvider theme={muiThemeNext(AccentColor())}>
            <div
              className="row"
              style={{ width: '100%', height: '65px', padding: '10px', backgroundColor: 'white' }}
            >
              <h2 style={{ textAlign: 'center', margin: '8px 0' }}>
                Ticket #{this.props.ticketDetails.ticket_number}
                &nbsp;
                <TicketStatusIcon
                  status={this.props.ticketDetails.status}
                  style={{ fontSize: '41%' }}
                />
              </h2>
            </div>
            <div
              className="row"
              style={{
                width: '100%',
                height: '29px',
                padding: '0 10px',
                backgroundColor: 'white',
              }}
            >
              <div className={headerColumns}>
                <div style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.pageView(pageViewHeaders.DETAILS)}
                    style={{
                      color: AccentColor(),
                      fontFamily: 'Circular-Bold',
                      borderBottom:
                        this.state.openView === pageViewHeaders.DETAILS.name ? '2px solid' : 'none',
                    }}
                  >
                    Details
                  </button>
                </div>
              </div>
              {!hostIsBoardwalk() &&
                this.props.ticketDetails.tasks.length > 0 && (
                  <div className={headerColumns}>
                    <div style={{ textAlign: 'center' }}>
                      <button
                        type="button"
                        className="link-button"
                        onClick={() => this.pageView(pageViewHeaders.TASKS)}
                        style={{
                          color: AccentColor(),
                          fontFamily: 'Circular-Bold',
                          borderBottom:
                            this.state.openView === pageViewHeaders.TASKS.name
                              ? '2px solid'
                              : 'none',
                        }}
                      >
                        Tasks
                      </button>
                    </div>
                  </div>
                )}
              <div className={headerColumns}>
                <div style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    className="link-button"
                    onClick={() => this.pageView(pageViewHeaders.EVENTS)}
                    style={{
                      color: AccentColor(),
                      fontFamily: 'Circular-Bold',
                      borderBottom:
                        this.state.openView === pageViewHeaders.EVENTS.name ? '2px solid' : 'none',
                    }}
                  >
                    History
                  </button>
                </div>
              </div>
            </div>
            <div
              onSubmit={handleSubmit}
              style={{
                padding: '15px',
                height: 'calc(100% - 155px)',
                overflow: 'scroll',
                backgroundColor: '#fbfbfb',
              }}
            >
              <CSSTransitionGroup
                transitionName="fade_out_buttons"
                transitionEnterTimeout={200}
                transitionLeaveTimeout={200}
              >
                {this.state.openView === pageViewHeaders.DETAILS.name && (
                  <div className="row">
                    {/************ Ticket Information **************/}
                    <h3 style={{ margin: '0 0 15px' }}>Overview</h3>
                    {this.renderClaimTicket()}
                    {this.renderAssignTickets()}
                    {this.renderAcknowledgeTicket()}
                    <TicketInformationForm
                      ticketInformation={this.props.ticketDetails}
                      jobStarted={this.state.jobStarted}
                      toggleContractorDialog={this.toggleContractorDialog}
                      endPauseJob={this.toggleEndJobDialog}
                    />
                  </div>
                )}

                {this._renderTicketTasks()}

                {this.state.openView === pageViewHeaders.EVENTS.name && (
                  <div className="row">
                    <h3 style={{ margin: '0 0 15px' }}> History </h3>
                    {/************ Ticket Event History **************/}
                    <Card style={style.transaction_card}>
                      <CardText style={{ padding: '0 10px' }}>
                        <EventTimeline events={deepDiver(this.props.ticketDetails, 'events')} />
                      </CardText>
                    </Card>
                  </div>
                )}

                {this.renderAssignTicketForm()}

                {this.state.openView === pageViewHeaders.SHOWCONTRACTOR.name && (
                  <div className="row">
                    <h3 style={{ margin: '0 0 15px' }}> Contractor Needed </h3>
                    {/************ Ticket Request a Contractor Form **************/}
                    <Card style={style.transaction_card}>
                      <CardText style={{ padding: '30px 10px' }}>
                        <RequestContractorForm
                          onSubmit={this.requireContractor}
                          handleClose={this.toggleContractorDialog}
                          isOpen={this.state.showContractorDialog}
                        />
                      </CardText>
                    </Card>
                  </div>
                )}

                {this.state.openView === pageViewHeaders.SHOWENDJOB.name && (
                  <div className="row">
                    <h3 style={{ margin: '0 0 15px' }}> End/Pause Job </h3>
                    {/************ Ticket End/Pause Job Form **************/}
                    <Card style={style.transaction_card}>
                      <CardText style={{ padding: '30px 10px' }}>
                        <FinishJobForm
                          onSubmit={this.submitCompleteJob}
                          stepOne={this.state.completeStepNumber === 1}
                          stepTwo={this.state.completeStepNumber === 2}
                          enableSignButton={this.enableSignButton}
                          pauseJob={this.pauseJob}
                        />
                      </CardText>
                    </Card>
                    {this._renderPauseDeferJob()}
                  </div>
                )}
              </CSSTransitionGroup>
            </div>
            <div
              style={{
                flex: '0 0 auto',
                margin: '8px 4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
              }}
            >
              <FooterButtons
                backName={this.footerBackButtonVerbiage()}
                submitAction={this.submitButtonAction}
                submitName={this.submitButtonVerbiage()}
                backAction={this.footerBackButtonAction}
                hideSubmitButton={this.hideSubmitButton()}
                disableSubmitOverride={this.shouldDisableSubmitButton()}
              />
            </div>
          </MuiThemeProvider>
        );
      }

      _renderTicketTasks = () => {
        if (hostIsBoardwalk()) return;
        if (this.state.openView !== pageViewHeaders.TASKS.name) return;

        return (
          <div className="row">
            <h3 style={{ margin: '0 0 15px' }}> Tasks </h3>
            <Card style={style.transaction_card}>
              <CardText style={{ padding: '0 10px' }}>
                <TaskList
                  tasks={deepDiver(this.props.ticketDetails, 'tasks')}
                  formName={pageViewHeaders.TASKS.formName}
                  onClickAction={this.createOrUpdateTask}
                  ticketStatus={this.props.ticketDetails.status}
                  readOnly
                />
              </CardText>
            </Card>
          </div>
        );
      };

      renderAssignTickets = () => {
        if (!this.props.assignTickets) return;

        return (
          <div className="row" style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h4 style={{ textAlign: 'justify' }}>Assign Ticket</h4>
            <p style={{ textAlign: 'justify' }}>
              You can assign this ticket to another staff member by clicking the button below.
              Alternatively, you can claim this ticket for yourself by clicking "Claim Ticket".
            </p>
            <div className="row" style={{ marginTop: '10px' }}>
              <FlatButton
                label="Assign Ticket"
                primary
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={{
                  color: 'white',
                }}
                onClick={this.toggleAssignTicket}
              />
            </div>
            {this.renderClaimTicketButton()}
          </div>
        );
      };

      _renderPauseDeferJob = () => {
        if (this.state.completeStepNumber !== 1) return;

        return (
          <div style={{ textAlign: 'center', paddingBottom: '10px', marginTop: '15px' }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={this.pauseJob}
              style={{ borderWidth: '2px' }}
            >
              Pause <PauseIcon style={{ fontSize: '21px', marginLeft: '8px' }} />
            </Button>
            <Button color="primary" variant="outlined" onClick={this.deferJob} style={style.button}>
              Defer <DeferIcon style={{ fontSize: '21px', marginLeft: '8px' }} />
            </Button>
          </div>
        );
      };

      renderAcknowledgeTicket = () => {
        if (!this.props.ticketDetails.assigned) return;
        if (!['new', 'Reviewed', 'Scheduled'].includes(this.props.ticketDetails.status)) return;

        return (
          <div className="row" style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h4 style={{ textAlign: 'justify' }}>Acknowledge Ticket</h4>
            <p style={{ textAlign: 'justify' }}>
              Acknowledge this ticket so you can confirm you will be working on this ticket.
            </p>
            <FlatButton
              label="Acknowledge Ticket"
              primary
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{
                color: 'white',
              }}
              onClick={this.acknowledgeTicket}
            />
          </div>
        );
      };

      renderClaimTicketButton = () => {
        if (!this.props.claimTickets) return;
        if (this.props.ticketDetails.assigned) return;

        return (
          <div className="row" style={{ marginTop: '10px' }}>
            <FlatButton
              label="Claim Ticket"
              primary
              hoverColor="grey"
              style={{
                color: AccentColor(),
              }}
              onClick={this.claimTicket}
            />
          </div>
        );
      };

      renderClaimTicket = () => {
        if (this.props.ticketDetails.assigned) return;
        if (!this.props.claimTickets) return;
        if (this.props.assignTickets) return;

        return (
          <div className="row" style={{ textAlign: 'center', marginBottom: '30px' }}>
            <h4 style={{ textAlign: 'justify' }}>Claim Ticket</h4>
            <p style={{ textAlign: 'justify' }}>
              This ticket has not been assigned to you. If you would like to claim the ticket, click
              the button below.
            </p>
            {this.renderClaimTicketButton()}
          </div>
        );
      };

      renderAssignTicketForm = () => {
        if (this.state.openView !== pageViewHeaders.ASSIGNTICKET.name) return;

        return (
          <div className="row">
            <h3 style={{ margin: '0 0 15px' }}> Assign Ticket </h3>
            <Card style={style.transaction_card}>
              <CardText style={{ padding: '30px 10px' }}>
                <AssignTicketForm
                  onSubmit={this.assignTicket}
                  handleClose={this.toggleContractorDialog}
                  isOpen={this.state.showContractorDialog}
                  maintenanceStaff={this.props.maintenanceStaff}
                />
              </CardText>
            </Card>
          </div>
        );
      };
    }
  )
);
